//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapState, mapMutations} from 'vuex'
import Menu from '../../components/menu/Menu.vue'
import MenuMb from '../../components/menu/MenuMb.vue'
import {campaignMenu, campaignInfo, campaignGoods, getCartNum} from '../../service/index'
import {pushChildren} from '../../utils/storage'

export default {
  data() {
    return {
      navMenu: [],
      currentActivityEnd: false
    }
  },
  components: {
    Menu, MenuMb
  },
  created() {
    this.keepLang()
    // this.initFromStore();
    //this.getMenu();
  },
  computed: {
    ...mapState([
      'global', 'campaign'
    ])
  },
  mounted(){
    this.getMenu();
  },
  activated(){
  },
  watch: {
    $route(to, from) {
      if (from.query.cid !== to.query.cid) {
        this.navMenu=[]
        this.getMenu();
      }
    }
  },
  methods: {
    ...mapMutations({
      saveCampaignInfo: 'INIT_CAMPAIGN',
      initMenu: 'INIT_MENU',
      initFromStore: 'INIT_CAMPAIGN_STORE',
      initCartNum: 'INIT_CART_NUM',
      initGoods: 'INIT_GOODS'
    }),
    async getMenu() {
      const camId = this.$route.params.id || this.$route.query.cid
      const responseCampaign = await campaignInfo(camId);
      if (responseCampaign.data) {
        const dateTime = new Date().getTime()
        this.saveCampaignInfo(responseCampaign.data)
        const menu = await campaignMenu(camId);
        if(menu.status==-3){
          this.currentActivityEnd  = true
        }
        const parent = menu.data.types || [];
        const children = menu.data.cats || [];
        pushChildren(parent, children)
        this.navMenu = parent;
        this.initMenu(parent);
        const cartNum = await getCartNum(camId)
        this.initCartNum({ cartNum: cartNum.data })
      }
    },
    keepLang(){
      let locale = localStorage.locale;
      this.$i18n.locale = locale === 'en' ? locale : 'zh';
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/nav/Nav.vue